import React, { useState, useRef, memo } from "react";
import Draggable from "react-draggable";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
////// Mui
import { LinearProgress, Paper } from "@mui/material";
import { Dialog, DialogTitle, DialogContent } from "@mui/material";
import { Box, Grid, Typography, useTheme, useMediaQuery } from "@mui/material";
////// Store
import { setPopupInv2 } from "../../../redux/slices/popupSlice";
import { setFormTouchedInv } from "../../../redux/slices/formTouchedSlice";
////// Controls & Components
import ButtonAction from "../Buttons/ButtonAction";
import ConfirmTouched from "./ConfirmTouched";

function PaperComponent(props) {
  return (
    <Draggable handle="#draggable-popupinv2" cancel={'[class*="popupinv2-cancel"]'}>
      <Paper {...props} />
    </Draggable>
  );
}

const PopupInv2 = memo((props) => {
  const { title, children } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const theme = useTheme();
  const lgMediaDown = useMediaQuery(theme.breakpoints.down("lg"));
  const { loadingStatus } = useSelector((state) => state.loadingStatusSlice);
  const { formTouchedInv } = useSelector((state) => state.formTouchedSlice);
  const [confirmTouched, setConfirmTouched] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
    type: "",
  });
  const { popupInv2 } = useSelector((state) => state.popupSlice);

  const invCompRef = useRef();

  const childrenWithProps = React.Children.map(children, (child) => {
    // Checking isValidElement is the safe way and avoids a typescript error too.
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { ref: invCompRef });
    }
    return child;
  });

  function handleEscClose() {
    if (!formTouchedInv) {
      confirmEscClose();
    } else {
      setConfirmTouched({
        isOpen: true,
        title: t("popup.you_have_unsaved_changes"),
        onBackToPage: () => [setConfirmTouched({ ...confirmTouched, isOpen: false })],
        onSave: () => [
          invCompRef.current.handleSubmit(),
          setConfirmTouched({ ...confirmTouched, isOpen: false }),
          dispatch(setFormTouchedInv(false)),
        ],
        onConfirm: () => [
          confirmEscClose(),
          setConfirmTouched({ ...confirmTouched, isOpen: false }),
          dispatch(setFormTouchedInv(false)),
        ],
      });
    }
  }

  function confirmEscClose() {
    dispatch(setPopupInv2(false));
  }

  return (
    <>
      <Dialog
        open={popupInv2}
        maxWidth="xl"
        fullWidth={false}
        disableEnforceFocus // property for CreateMenu not to exceed Maximum call stack
        sx={{
          "& .MuiDialog-container": {
            justifyContent: "flex-center",
            alignItems: "flex-start",
          },
        }}
        PaperProps={{
          sx: {
            mt: 2,
            m: lgMediaDown ? 0.75 : undefined,
          },
        }}
        onClose={handleEscClose}
        PaperComponent={PaperComponent}
        BackdropProps={{ style: { backgroundColor: "rgba(0,0,0,0.1)" } }}
      >
        <DialogTitle sx={{ bgcolor: "#bdd600" }}>
          <Grid container item xs={12}>
            <Grid container item xs={10} style={{ cursor: "move" }} id="draggable-popupinv2">
              <Grid item xs={12}>
                <Typography variant="h6">{title}</Typography>
              </Grid>
            </Grid>

            <Grid container item xs={2} justifyContent={"flex-end"} id="popupinv2-cancel">
              <ButtonAction color="secondary" onClick={() => handleEscClose()}>
                {t("button.esc")}
              </ButtonAction>
            </Grid>
          </Grid>
        </DialogTitle>

        {/* LiniarProgress */}
        <Box sx={{ width: "100%" }}>
          {loadingStatus === true ? <LinearProgress /> : <LinearProgress variant="determinate" value={100} />}
        </Box>

        <DialogContent>{childrenWithProps}</DialogContent>
      </Dialog>

      <ConfirmTouched confirmTouched={confirmTouched} setConfirmTouched={setConfirmTouched} />
    </>
  );
});

export default PopupInv2;
